
























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { MarkViewModel } from '../../api/mark';
import global from '../../config/global';
@Component({})
export default class MapInfo extends Vue {
  @Prop() public MarkData!: MarkViewModel;
  public attachmentUrl: string = `${global.BACKGROUND_URL}/mark/`;
  public toHtml(content: string) {
    return content.replace(/\n/ig, '<br>');
  }
  public getAttachment(json: string) {
    if (json && json !== '') {
      return JSON.parse(json);
    } else {
      return [];
    }
  }

  @Emit('OnClick')
  public btnSearch_OnClick() {
    // this.$nextTick(() => {
    //   console.log(this);
    // });

    // this.$router.replace({name: 'search', query: {m: this.MarkData.id!.toString()}});
    return this.MarkData;
  }
}
